"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parse(lcid) {
    const lcidParts = {
        language: LANGIDFROMLCID(lcid),
        primary: PRIMARYLANGID(lcid),
        sub: SUBLANGID(lcid),
        sort: SORTIDFROMLCID(lcid)
    };
    return lcidParts;
}
exports.parse = parse;
exports.format = (arg1, arg2, arg3) => {
    if (typeof arg1 === 'object') {
        const lcidParts = arg1;
        return MAKELCID(lcidParts.language, lcidParts.sort);
    }
    if ((typeof arg1 === 'number') && (typeof arg2 === 'number')) {
        if (typeof arg3 === 'number') {
            const primary = arg1;
            const sub = arg2;
            const sort = arg3;
            return MAKELCID(MAKELANGID(primary, sub), sort);
        }
        else {
            const language = arg1;
            const sort = arg2;
            return MAKELCID(language, sort);
        }
    }
    return -1;
};
function MAKELANGID(primary, sub) {
    return ((sub << 10) + PRIMARYLANGID(primary));
}
exports.MAKELANGID = MAKELANGID;
function PRIMARYLANGID(langid) {
    return (langid & 0b00001111111111);
}
exports.PRIMARYLANGID = PRIMARYLANGID;
function SUBLANGID(langid) {
    return (langid & 0b11110000000000) >> 10;
}
exports.SUBLANGID = SUBLANGID;
function MAKELCID(langid, sortid) {
    return (((sortid & 0x0F) << 16) + (langid & 0xFFFF));
}
exports.MAKELCID = MAKELCID;
function LANGIDFROMLCID(lcid) {
    return (lcid & 0xFFFF);
}
exports.LANGIDFROMLCID = LANGIDFROMLCID;
function SORTIDFROMLCID(lcid) {
    return ((lcid >> 16) & 0x0F);
}
exports.SORTIDFROMLCID = SORTIDFROMLCID;
//# sourceMappingURL=lcid-impl.js.map